import { removeFalsy } from "util/array";

const emptyString = (string) => !(string && string.length > 0);

const compareStrings = (strings, trim = true, caseInsensitive = false) => {
  if (strings.length < 2) {
    throw new Error("At least two strings to compare must be provided");
  }

  let baseString;
  let allStringsMatch = true;

  strings.forEach((string) => {
    if (typeof string !== "string")
      throw new Error("Only string values may be provided");

    let compareString = trim ? string.trim() : string;
    compareString = caseInsensitive ? string.toLowerCase() : compareString;

    if (!baseString) {
      baseString = compareString;
    } else if (baseString !== compareString) {
      allStringsMatch = false;
    }
  });

  return allStringsMatch;
};

const arrayFromString = (str = "", sep = ",", trim = true) =>
  removeFalsy(str.split(sep).map((s) => (trim ? s.trim() : s)));

export { emptyString, compareStrings, arrayFromString };
